<div class="version-dropdown" *ngIf="haveData">
  <app-version-menu [projectId]="pid"></app-version-menu>

  <ops-search-bar
    (searchedParamter)="onSearchItems($event)"
    class="search"
  ></ops-search-bar>
</div>

<div class="great-white">
  <div class="main-wrapper">
    <div class="zero-screen loading" *ngIf="isLoading">
      <div class="instructions">
        {{ 'productionCost.main.loading' | translate }}
        <div class="cssload-container">
          <div class="cssload-speeding-wheel"></div>
        </div>
      </div>
    </div>

    <div
      class="zero-screen"
      *ngIf="
        !isLoading &&
        !projectCost.projectDepartments?.length &&
        !addDepartment &&
        !addItemGroup
      "
    >
      <img
        class="clickable"
        src="assets/purple-circle-purple-plus-big.svg"
        (click)="onShowAddDepartmentScreen()"
      />
      <div class="instructions">
        {{ 'productionCost.main.addFirstDepartment' | translate }}
      </div>
    </div>

    <div class="add-department-screen" *ngIf="addDepartment">
      <div class="title">
        {{ 'productionCost.main.selectDepartment' | translate }}
      </div>
      <div class="departments">
        <!-- prettier-ignore -->
        <div class="department" *ngFor="let department of departments | orderBy: 'name':false:'case-insensitive'"
          autofocus
          tabindex="0"
          role="button" 
          enterPress="onAddProjectDepartment(department.name, department.isTeam)"  
          (keydown.enter)="onAddProjectDepartment(department.name, department.isTeam)"

          (click)="onAddProjectDepartment(department.name, department.isTeam)"
        >
          <div class="label">{{ department.name | translate  }}</div>
        </div>
      </div>
      <div
        class="cancel-btn"
        tabindex="0"
        role="button"
        enterPress="onHideAddDepartmentScreen()"
        (keydown.enter)="onHideAddDepartmentScreen()"
        (click)="onHideAddDepartmentScreen()"
      >
        {{ 'productionCost.main.cancel' | translate }}
      </div>
    </div>

    <div class="template-screen" *ngIf="addItemGroup">
      <div class="header-row">
        <div class="dept-name">
          <div class="title">
            {{ 'productionCost.main.departmentName' | translate }}
          </div>
          <input
            tabindex="0"
            autofocus
            focusSelect
            [(ngModel)]="addItemGroup.name"
            placeholder="{{
              'productionCost.main.departmentNamePlaceholder' | translate
            }}"
          />
        </div>
        <div id="search-bar-positions" class="search">
          <img
            src="assets/search-purple.svg"
            alt="{{ 'productionCost.main.searchPosition' | translate }}"
          />
          <input
            focusSelect
            tabindex="0"
            id="search-input"
            value="{{ searchPosition }}"
            (keyup)="onTypeSearch($event)"
            placeholder="{{
              'productionCost.main.searchPlaceholder' | translate
            }}"
          />
        </div>
        <ops-dropdown
          id="search-positions-m2"
          parentId="search-bar-positions"
          [options]="searchResults"
          [isMultiSelect]="false"
          (valueSelected)="onPositionSelected($event)"
          class="position-search-dropdown"
        ></ops-dropdown>
      </div>
      <div class="positions">
        <div
          class="position"
          *ngFor="let position of displayedPositions"
          tabindex="0"
          role="button"
          enterPress="togglePosition(position)"
          (keydown.enter)="togglePosition(position)"
          (click)="togglePosition(position)"
        >
          <div class="checkbox">
            <img
              src="assets/checkmark-square-white-in-purple2.svg"
              *ngIf="position.isSelected"
            />
          </div>
          <div class="label" [class.selected]="position.isSelected">
            {{ position.name | translate }}
          </div>
        </div>
      </div>
      <div class="button-row">
        <div
          class="cancel-btn"
          tabindex="0"
          role="button"
          enterPress="onCancelPositions()"
          (keydown.enter)="onCancelPositions()"
          (click)="onCancelPositions()"
        >
          {{ 'productionCost.main.cancel' | translate }}
        </div>
        <div
          class="save-btn"
          tabindex="0"
          role="button"
          enterPress="onOkPositions()"
          (keydown.enter)="onOkPositions()"
          (click)="onOkPositions()"
        >
          {{ 'productionCost.main.ok' | translate }}
        </div>
      </div>
    </div>

    <div
      #content
      class="content-wrapper"
      *ngIf="
        !isLoading &&
        projectCost.projectDepartments?.length > 0 &&
        !addDepartment &&
        !addItemGroup
      "
    > 
    <div *ngIf="isRefreshing" class="cssload-container-refresh">
      <div class="cssload-speeding-wheel-refresh"></div>
    </div>

      <div class="header-row">
        <div class="title">
          {{ 'productionCost.main.headerDepartmentName' | translate }}
        </div>
        <div class="actual">
          {{ 'productionCost.main.actualCost' | translate }}
        </div>
        <div class="estimate">
          {{ 'productionCost.main.estimated' | translate }}
        </div>
      </div>
      <ops-cost-accordion
        class="accordion-category"
        [categories]="accordionList"
        [refreshTrigger]="refreshTrigger"
        [projectId]="projectCost._id"
        [companyId]="getCurrentCompanyId()"
        [(renameId)]="renameDepartmentId"
        (recalculateTotal)="onRecalculate()"
        (actionSelected)="onDepartmentAction($event)"
        (moveItem)="onMoveItem($event)"
        (addNewPaidByOption)="onAddNewPaidByOption($event)"
      >
      </ops-cost-accordion>
      <div class="bottom-row">
        <div
          class="add-department-btn"
          tabindex="0"
          role="button"
          enterPress="onShowAddDepartmentScreen()"
          (keydown.enter)="onShowAddDepartmentScreen()"
          (click)="onShowAddDepartmentScreen()"
        >
          {{ 'productionCost.main.addDepartment' | translate }}
        </div>
        <div class="total-section">
          <div class="total-category">
            <div class="label">
              {{ 'productionCost.main.inHouseExpense' | translate }}
            </div>
            <div class="number">
              {{ companyBaseCurrency }}{{ '&thinsp;'
              }}{{ inHouseExpense | number : '.0-0' }}
            </div>
          </div>
          <div class="total-category">
            <div class="label">
              {{ 'productionCost.main.projectExpense' | translate }}
            </div>
            <div class="number">
              {{ companyBaseCurrency }}{{ '&thinsp;'
              }}{{ projectExpense | number : '.0-0' }}
            </div>
          </div>
          <div class="total-category">
            <div class="label extended">
              {{ 'productionCost.main.approvedBudget' | translate }}
              <div class="small">
                {{ 'productionCost.main.feesTaxIncl' | translate }}
              </div>
            </div>
            <div class="number">
              {{ companyBaseCurrency }}{{ '&thinsp;'
              }}{{ projectCost?.estimatedCost | number : '.0-0' }}
            </div>
          </div>
          <div class="total-category">
            <div class="label">
              {{ 'productionCost.main.profitability' | translate }}
            </div>
            <div class="number">
              {{ companyBaseCurrency }}{{ '&thinsp;'
              }}{{
                profitability | number : '.0-0' 
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal components for creating bank accounts and credit cards -->
<ops-bank-account-create-modal
  id="bank-account-create-modal"
  (bankAccountCreated)="onBankAccountCreated()"
></ops-bank-account-create-modal>

<ops-credit-card-create-modal
  id="credit-card-create-modal"
  (creditCardCreated)="onCreditCardCreated()"
></ops-credit-card-create-modal>
